<template>
  <v-container>
    <slot name="mstemplate"></slot>
  </v-container>
</template>

<style scoped>
.container {
  max-width: 800px;
  margin-left: 0;
}
</style>

<script>
export default {
  name: 'container-wrap',
  components: {},
  data: () => ({ }),
};
</script>
